import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form, Col, Row, Dropdown, Tabs, Tab } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import {
  fetchReportList,
  downLoadReportDatewise,
  downLoadCombineReportDatewise,
  downloadCsvDatewiseReport,
  downloadCsvCurrentReport,
} from "../../../store/actions/reportsAction";
import DeleteConditionPopup from "./DeleteConditionPopup";
import ToggelActivatateConditionPopup from "./ToggelActivatateConditionPopup";
import ShowConditionUrlPopup from "./ShowConditionUrlPopup";
import ManageWard from "./ManageWard";
import styles from "../scheduleReports/ScheduleWiseReportList.module.css";
import download from "../../../assets/images/download.png";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
import Loader from "../../common/loader/Loader";
import MainReport from "../scheduleReports/MainReport";
import ScheduleWiseReportList from "../scheduleReports/ScheduleWiseReportList";

const ReportList = () => {
  const [downloadType, setDownloadType] = useState("xlsx"); // 'xlsx' or 'csv'
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const handleClose = () => {
    setSelectedDate(null);
    setShow(false);
    setShow1(false);
  };
  const handleShow = () => {
    setSelectedDate(moment(new Date()).format("YYYY-MM-DD"));
    setShow(true);
  };
  // Ensures both date and type are set and modal is opened, so API is called
  const handleDatewiseDownload = (type) => {
    setSelectedDate(moment(new Date()).format("YYYY-MM-DD"));
    setDownloadType(type);
    setShow(true);
  };
  const handleShow1 = () => {
    setSelectedCombineDate(moment(new Date()).format("YYYY-MM-DD"));
    setShow1(true);
  };

  const [modalShow, setModalShow] = useState(false);

  const [selectCondition, setSelectCondition] = useState(null);
  const [selectClient, setselectClient] = useState(null);

  const [isShow, setIsShow] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedCombineDate, setSelectedCombineDate] = useState();
  const [activeTab, setActiveTab] = useState("");

  const [filterOption, setFilterOption] = useState({});
  const [deleteRec, setDeleteRec] = useState(null);
  const [conditionLink, setConditionLink] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [conditionLinkModalShow, setConditionLinkModalShow] = useState(false);
  const [toggleActivateRec, setToggleActivateRec] = useState(null);
  const [toggleActivateStatus, setToggleActivateStatus] = useState(null);
  const [toggleActivateModalShow, setToggleActivateModalShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const admin = useSelector((state) => state.admin);
  const { adminDetail } = admin;
  const {
    reports,
    updatedAt,
    filePath,
    downloadFileOfCurrentDate,
    downloadFileOfDate,
    downloadCombineFileOfDate,
    pagination,
    isLoader,
    isDownloadLoader,
    isRecordUpdated,
    downloadFileOfCurrentDateCsv,
    downloadFileOfDateCsv,
    downloadAllFilesOfDateCsv,
    error: apiError,
  } = useSelector((state) => {
    return state.reports;
  });

  const cc = downloadFileOfCurrentDate || downloadFileOfDate || reports;

  useEffect(() => {
    if (location?.state?.previousActiveTab) {
      setActiveTab(location?.state?.previousActiveTab);
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state?.previousActiveTab]);

  useEffect(() => {
    console.log(
      "selectedDate or downloadType changed:",
      selectedDate,
      downloadType
    );
    if (selectedDate && downloadType) {
      if (downloadType === "xlsx") {
        dispatch(downLoadReportDatewise({ dateData: selectedDate })).then(
          ({ payload }) => {
            // if (payload && payload.success && payload.data) {
            //   window.open(payload?.data?.filePath, "_blank");
            // }
          }
        );
      } else if (downloadType === "csv") {
        dispatch(downloadCsvDatewiseReport({ dateData: selectedDate })).then(
          ({ payload }) => {
            // if (payload && payload.success && payload.data) {
            //   window.open(payload?.data?.filePath, "_blank");
            // }
          }
        );
      }
      // Do NOT setDownloadType(null) here, so type persists for further date changes
    }
  }, [selectedDate, downloadType]);

  useEffect(() => {
    if (
      selectedCombineDate ||
      selectedCombineDate === moment(new Date()).format("YYYY-MM-DD")
    ) {
      dispatch(
        downLoadCombineReportDatewise({ dateData: selectedCombineDate })
      );
    }
  }, [selectedCombineDate]);
  window.history.replaceState({}, document.title);

  useEffect(() => {
    if (!location?.state?.previousActiveTab) {
      dispatch(fetchReportList(filterOption));
      dispatch(downloadCsvCurrentReport(filterOption));
    }
  }, [filterOption, isRecordUpdated]);

  // const emailReport = (e) => {
  //   dispatch(emailReportList(filterOption)).then(({ payload }) => {
  //     if (payload.success) {
  //       setIsShow(true);
  //     }
  //   });
  // };

  const hideHandle = () => {
    setModalShow(false);
    setSelectCondition(null);
    setDeleteModalShow(false);
    setDeleteRec(null);
    setToggleActivateModalShow(false);
    setToggleActivateRec(null);
    setConditionLinkModalShow(false);
  };

  //  Report Navigate
  const navigateReport = () => {
    navigate("/report");
  };
  //  Workforce Navigate
  const navigateWorkforce = () => {
    navigate("/workforce");
  };

  const navigateReportTime = () => {
    navigate("/report-time");
  };

  const hideHandlerRes = () => {
    setIsShow(false);
  };
  const downloadCurerntFile = (type) => {
    if (type === "xlsx") {
      if (downloadFileOfCurrentDate) {
        window.open(downloadFileOfCurrentDate, "_blank");
      } else {
        dispatch(fetchReportList(filterOption));
      }
    } else if (type === "csv") {
      if (downloadFileOfCurrentDateCsv) {
        window.open(downloadFileOfCurrentDateCsv, "_blank");
      } else {
        dispatch(downloadCsvCurrentReport(filterOption)).then(({ payload }) => {
          if (payload && payload.success && payload.data) {
            window.open(payload.data, "_blank");
          }
        });
      }
    }
  };

  const handleSubmit = () => {
    if (!selectedDate) return;

    let hour, minute;
    if (selectedTime) {
      [hour, minute] = selectedTime.split(":").map(Number);
      const payload = {
        dateData: selectedDate,
        ...(selectedTime ? { hour, minute } : {}),
      };

      dispatch(downLoadReportDatewise(payload));
    }
  };

  const handleReset = () => {
    setSelectedDate(moment(new Date()).format("YYYY-MM-DD")); // reset to current date
    setSelectedTime(""); // clear time
  };

  return (
    <>
      {/* Modal Download Date wise report */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          {" "}
          <h4 align="center" style={{ textAlign: "center", flex: "auto" }}>
            Date Wise Report
          </h4>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3 px-5">
            <Form.Label>Date of the Report</Form.Label>
            <Form.Control
              type="date"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholder="select"
              defaultValue={moment(new Date()).format("YYYY-MM-DD")}
              max={moment(new Date()).format("YYYY-MM-DD")}
              autoFocus
              onChange={async (e) => {
                setSelectedDate(e.target.value);
                // API call will be triggered by useEffect when selectedDate changes
              }}
            />
          </Form.Group>
          {isDownloadLoader && <Loader />}
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column justify-content-center">
          {downloadType === "csv" && downloadFileOfDateCsv && !apiError && (
            <a
              className="downloadBtn rounded cursor-pointer"
              href={downloadFileOfDateCsv}
              target="_blank"
            >
              <img src={download} alt="img" /> Download Report (CSV)
            </a>
          )}
          {downloadType === "xlsx" && downloadFileOfDate && !apiError && (
            <a
              className="downloadBtn rounded cursor-pointer"
              href={downloadFileOfDate}
              target="_blank"
            >
              <img src={download} alt="img" /> Download Report (XLSX)
            </a>
          )}
          {apiError && <p className="textWarning">{apiError?.message}</p>}

          <span
            className="cancel-btn mt-4 cursor-pointer"
            onClick={handleClose}
          >
            Cancel
          </span>
        </Modal.Footer>
      </Modal>
      {/* End Model */}
      {/* Modal Download Date wise Combine report */}
      <Modal show={show1} onHide={handleClose}>
        <Modal.Header closeButton>
          {" "}
          <h4 align="center" style={{ textAlign: "center", flex: "auto" }}>
            Date Wise Combine Report
          </h4>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3 px-5">
            <Form.Label>Date of the Report</Form.Label>
            <Form.Control
              type="date"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholder="select"
              defaultValue={moment(new Date()).format("YYYY-MM-DD")}
              max={moment(new Date()).format("YYYY-MM-DD")}
              autoFocus
              onChange={async (e) => {
                setSelectedCombineDate(e.target.value);
              }}
            />
          </Form.Group>
          {isDownloadLoader && <Loader />}
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column justify-content-center">
          {downloadCombineFileOfDate && !apiError && (
            <a
              className="downloadBtn rounded cursor-pointer"
              href={downloadCombineFileOfDate}
              target="_blank"
            >
              <img src={download} alt="img" /> Download Report
            </a>
          )}
          {apiError && <p className="textWarning">{apiError?.message}</p>}

          <span
            className="cancel-btn mt-4 cursor-pointer"
            onClick={handleClose}
          >
            Cancel
          </span>
        </Modal.Footer>
      </Modal>
      {/* End Model */}
      {/* {isLoader && <Loader />} */}
      <div className="container overflow-hidden">
        <ManageWard
          show={modalShow}
          onHide={hideHandle}
          title={selectClient ? "Edit Ward" : "Add Ward"}
          selectClient={selectClient}
          setModalShow={setModalShow}
        />
        <DeleteConditionPopup
          onHide={hideHandle}
          deleteRec={deleteRec}
          deleteModalShow={deleteModalShow}
          setDeleteModalShow={setDeleteModalShow}
        />
        <ShowConditionUrlPopup
          onHide={hideHandle}
          conditionLink={conditionLink}
          conditionLinkModalShow={conditionLinkModalShow}
          setConditionLinkModalShow={setConditionLinkModalShow}
        />
        <ToggelActivatateConditionPopup
          onHide={hideHandle}
          toggleActivateRec={toggleActivateRec}
          toggleActivateStatus={toggleActivateStatus}
          toggleActivateModalShow={toggleActivateModalShow}
          setToggleActivateModalShow={setToggleActivateModalShow}
        />

        <h1 className="main-title">Reports</h1>
        <div className="block-section">
          <Button
            className="btn-primary reportBtn me-4"
            onClick={navigateReport}
          >
            Manage Reports
          </Button>
          <Button
            variant="outline-primary reportBtn me-4"
            onClick={navigateWorkforce}
          >
            Workforce Capacity
          </Button>

          {/* {adminDetail?.isAdmin && (
            <Button
              variant="outline-primary reportBtn"
              onClick={navigateReportTime}
            >
              Set Report Time
            </Button>
          )} */}
        </div>

        {/* <div className="block-section">
          <p className="txtHeading">You can download the report</p>

          {cc && cc.length ? (
            <>
              <a
                onClick={downloadCurerntFile}
                className="downloadBtn rounded cursor-pointer"
                href="javascript:void(0)"
                target="_blank"
              >
                <img src={download} alt="img" /> Download Current Report
              </a>
            </>
          ) : (
            <>
              <a
                className="downloadBtn rounded not-allowed disable"
                style={{ cursor: "not-allowed" }}
              >
                <img src={download} alt="img" /> Download Current Report
              </a>
            </>
          )}

          <Button
            className="reportBtn1 cursor-pointer outline-light"
            variant=""
            href="#"
            onClick={handleShow}
          >
            <img src={download} alt="img" /> Download Date Wise Report
          </Button>
        </div> */}
        {/* <h1 className="title">Manage Report</h1> */}
        <div className="block-section">
          <p className="txtHeading">You can download the report</p>
          <div style={{ display: "flex" }}>
            {cc && cc.length ? (
              <Dropdown
                style={{ display: "inline-block", marginRight: "16px" }}
              >
                <Dropdown.Toggle
                  style={{
                    background: "#19c1a3",
                    color: "#fff",
                    border: "none",
                    fontWeight: 600,
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "0 24px",
                    height: "48px",
                    fontSize: "18px",
                  }}
                  className="downloadBtn rounded cursor-pointer"
                  id="dropdown-current-download"
                >
                  <img
                    src={download}
                    alt="img"
                    style={{
                      marginRight: 6,
                      filter: "brightness(0) invert(1)",
                    }}
                  />
                  Download Current Report
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => downloadCurerntFile("xlsx")}>
                    Download as Excel
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => downloadCurerntFile("csv")}>
                    Download as CSV
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Dropdown
                style={{
                  display: "inline-block",
                  marginRight: "16px",
                  opacity: 0.6,
                }}
              >
                <Dropdown.Toggle
                  style={{
                    background: "#19c1a3",
                    color: "#fff",
                    border: "none",
                    fontWeight: 600,
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "0 24px",
                    height: "48px",
                    fontSize: "18px",
                  }}
                  className="downloadBtn rounded not-allowed disable"
                  id="dropdown-current-download"
                  disabled
                >
                  <img
                    src={download}
                    alt="img"
                    style={{
                      marginRight: 6,
                      filter: "brightness(0) invert(1)",
                    }}
                  />
                  Download Current Report
                </Dropdown.Toggle>
              </Dropdown>
            )}
            {/* <Dropdown style={{ display: 'inline-block' }}>
            <Dropdown.Toggle
              style={{ background: '#f6a04c', color: '#fff', border: 'none', fontWeight: 600, display: 'inline-flex', alignItems: 'center', padding: '0 24px', height: '48px', fontSize: '18px' }}
              className="reportBtn1 cursor-pointer outline-light"
              id="dropdown-datewise-download"
            >
              <img src={download} alt="img" style={{ marginRight: 6, filter: 'brightness(0) invert(1)' }} />
              Download Date Wise Report
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleDatewiseDownload("xlsx")}>Download as XLSX</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDatewiseDownload("csv")}>Download as CSV</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
          </div>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Select Date:</Form.Label>
                <Form.Control
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  style={{
                    height: "38px",
                    paddingRight: "28px",
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Select Time:</Form.Label>
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type="time"
                    value={selectedTime}
                    onChange={(e) => setSelectedTime(e.target.value)}
                    style={{
                      height: "38px",
                      paddingRight: "28px",
                    }}
                  />
                  {selectedTime && (
                    <button
                      type="button"
                      onClick={() => setSelectedTime("")}
                      style={{
                        position: "absolute",
                        right: "48px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        color: "#888",
                        fontSize: "16px",
                        lineHeight: "1",
                      }}
                      title="Clear time"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </Form.Group>
            </Col>
            <Col md={3} className="d-flex align-items-end gap-2">
              <Button onClick={handleSubmit} variant="primary">
                SUBMIT
              </Button>
              {/* <Button onClick={handleReset} variant="secondary">
                RESET
              </Button> */}
            </Col>
          </Row>
        </div>
        <Tabs
          activeKey={downloadType}
          onSelect={(key) => setDownloadType(key)}
          transition={false}
          id="noanim-tab-example"
          className="mb-3"
        >
          <Tab eventKey="xlsx" title="Reports for XLSX">
            <ScheduleWiseReportList selectedDate={selectedDate} downloadType={downloadType} />
          </Tab>
          <Tab eventKey="csv" title="Reports for CSV">
            <ScheduleWiseReportList selectedDate={selectedDate} downloadType={downloadType} />
          </Tab>
        </Tabs>
        <MainReport />
      </div>
      <ApiResponsePopup
        {...{
          hideHandlerRes,
          isRecordAdded: isShow,
          title: "Report Email ",
          successMsg: "Report emailed successfully.",
          errorRes: apiError?.message,
        }}
      />
    </>
  );
};

export default ReportList;
